module.exports = __webpack_public_path__ + "img/apostilas.ff83224e.jpg";